var inProgress = {};
var dataWebpackPrefix = "via-frontend-v2:";
// loadScript function to load a script via script tag
__webpack_require__.l = (url, done, key, chunkId) => {
	if(inProgress[url]) { inProgress[url].push(done); return; }
	var script, needAttach;
	if(key !== undefined) {
		var scripts = document.getElementsByTagName("script");
		for(var i = 0; i < scripts.length; i++) {
			var s = scripts[i];
			if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
		}
	}
	if(!script) {
		needAttach = true;
		// create error before stack unwound to get useful stacktrace later
		var error = new Error();
		function loadScript(src, retries) {
		  var script = document.createElement('script');
		  var retryAttempt = 5 - retries + 1;
		  var retryAttemptString = '&retry-attempt=' + retryAttempt;
		  var onScriptComplete;

		  script.charset = 'utf-8';
		  script.timeout = 120;
		  if (__webpack_require__.nc) {
		    script.setAttribute('nonce', __webpack_require__.nc);
		  }
		  script.src = src;

		  onScriptComplete = function(event) {
		    // avoid mem leaks in IE.
		    script.onerror = script.onload = null;
		    clearTimeout(timeout);
		    var chunk = installedChunks[chunkId];
		    if (chunk !== 0) {
		      if (chunk) {
		        if (retries === 0) {
		          var errorType =
		            event && (event.type === 'load' ? 'missing' : event.type);
		          var realSrc = event && event.target && event.target.src;
		          error.message =
		            'Loading chunk ' +
		            chunkId +
		            ' failed after 5 retries.\n(' +
		            errorType +
		            ': ' +
		            realSrc +
		            ')';
		          error.name = 'ChunkLoadError';
		          error.type = errorType;
		          error.request = realSrc;
		          chunk[1](error);
		          installedChunks[chunkId] = undefined;
		        } else {
		          setTimeout(function() {
		            var cacheBust = (function() {
		              return Date.now();
		            })();
		            +retryAttemptString;
		            var retryScript = loadScript(
		              jsonpScriptSrc(chunkId) + '?' + cacheBust,
		              retries - 1
		            );
		            document.head.appendChild(retryScript);
		          }, 0);
		        }
		      } else {
		        installedChunks[chunkId] = undefined;
		      }
		    }
		  };
		  var timeout = setTimeout(function() {
		    onScriptComplete({ type: 'timeout', target: script });
		  }, 120000);
		  script.onerror = script.onload = onScriptComplete;
		  return script;
		}

		var script = loadScript(jsonpScriptSrc(chunkId), 5);
	}
	inProgress[url] = [done];
	var onScriptComplete = (prev, event) => {
		// avoid mem leaks in IE.
		script.onerror = script.onload = null;
		clearTimeout(timeout);
		var doneFns = inProgress[url];
		delete inProgress[url];
		script.parentNode && script.parentNode.removeChild(script);
		doneFns && doneFns.forEach((fn) => (fn(event)));
		if(prev) return prev(event);
	}
	var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
	script.onerror = onScriptComplete.bind(null, script.onerror);
	script.onload = onScriptComplete.bind(null, script.onload);
	needAttach && document.head.appendChild(script);
};